import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit } from '@angular/core';
import { FormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, FormGroup, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PurchasingService } from '../services/purchasing.service';
import { VendorService } from '../services/vendor.service';

import { Location } from '@angular/common';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import * as FileSaver from 'file-saver';
import { GlobalSearchService } from '../services/globalsearchservice.service';
import { UsersService } from 'app/services/users.service';
import { PrintService } from 'app/services/print.service';


@Component({
	selector: 'app-vendors',
	templateUrl: './vendors.component.html',
	styleUrls: ['./vendors.component.scss']
})
export class VendorsComponent implements OnInit, AfterViewInit, OnDestroy {

	@ViewChild(MatSort, { static: false }) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild('vendorsearch') customersearch: ElementRef;
	@ViewChild('tableWrapper') tableWrapper: ElementRef;
	vendors: any = [];
	title = 'vendors';
	color: any = '';
	keywords: any = '';
	ready: boolean;
	filteredItems: any = [];
	results: any = [];
	vendosubscription: any = false;
	headercolumns: string[] = [];
	highlightedRowIndex = -1;
	@ViewChild('print_tablexlsx') printtablexlsx: ElementRef;
	searchForm: UntypedFormGroup;
	user: any;
	config: any;

	private destroy$ = new Subject<void>();

	constructor(private printService: PrintService, private purchasingService: PurchasingService, private globalSearchService: GlobalSearchService, public vendorService: VendorService, public router: Router, public location: Location, private userService: UsersService) { }

	ngOnInit(): void {

		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			if(this.config.env.package == 'tires'){
				this.headercolumns = [
					'actions',
					'supplierid',
					'bankref',
					'suppname',
					'address1',
					'telephone',
					// 'disabled'
				];
			}else{
				this.headercolumns = [
					'actions',
					'supplierid',
					'suppname',
					'address1',
					'telephone',
					// 'disabled'
				];
			}
		});

		this.user = this.userService.getLocalUser();


		this.ready = true;
		this.color = this.globalSearchService.getColor();

		const formGroup: UntypedFormGroup = new UntypedFormGroup({});
		formGroup.addControl('disabled', new UntypedFormControl(false, []), {})
		this.searchForm = formGroup;

		this.getAllVendors();

		this.searchForm.get('disabled').valueChanges.subscribe((newV) => {
			const data = { inc_disabled: !!newV };
			const search = this.customersearch.nativeElement.value;
			if (search == '') {
				this.getAllVendors(data);
			} else {
				this.filterVendors({ target: { value: search } });
			}
		});
	}

	getAllVendors(data?: { inc_disabled?: boolean }) {
		if (data == undefined) {
			data = { inc_disabled: false };
		}

		if (this.vendosubscription) {
			this.vendosubscription.unsubscribe();
		}

		this.vendosubscription = this.vendorService.getVendorsPost(data).subscribe((results: any) => {
			this.vendors = new MatTableDataSource(results);
			this.results = results;
			this.vendors.sort = this.sort;
			this.vendors.paginator = this.paginator;
			this.ready = true;
			this.highlightedRowIndex = results?.length > 0 ? 0 : -1;
			this.globalSearchService.vendorData.next(this.vendors);
		});
	}

	getCurrentPageRows(): any[] {
		if (!this.vendors || !(this.vendors instanceof MatTableDataSource)) {
			return [];
		}
		const data = this.vendors.filteredData || this.vendors.data || [];
		if (!this.paginator) {
			return data;
		}
		const start = this.paginator.pageIndex * this.paginator.pageSize;
		return data.slice(start, start + this.paginator.pageSize);
	}

	filterVendors(input: any) {
		this.ready = false;
		if (this.vendosubscription) {
			this.vendosubscription.unsubscribe();
		}
		const searchVal = input?.target?.value ?? '';
		const incDisabled = !!this.searchForm.get('disabled')?.value;
		this.vendosubscription = this.vendorService.getVendorSearch(searchVal, incDisabled).subscribe((results: any) => {
			this.ready = true;
			if (results?.length > 1) {
				this.vendors = new MatTableDataSource(results);
				this.results = results;
				this.vendors.sort = this.sort;
				this.vendors.paginator = this.paginator;
				this.highlightedRowIndex = 0;
			} else if (results?.length === 1) {
				this.router.navigate(['./vendors/' + results[0].supplierid]);
			} else {
				this.highlightedRowIndex = -1;
			}
			this.globalSearchService.vendorData.next(this.vendors);
		});
	}

	onSearchKeydown(event: KeyboardEvent): void {
		const rows = this.getCurrentPageRows();
		if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
			if (!rows.length) {
				return;
			}
			event.preventDefault();
			if (event.key === 'ArrowDown') {
				this.highlightedRowIndex = Math.min(this.highlightedRowIndex + 1, rows.length - 1);
			} else {
				this.highlightedRowIndex = Math.max(this.highlightedRowIndex - 1, 0);
			}
			this.scrollHighlightedIntoView();
			return;
		}
		if (event.key === 'Enter') {
			event.preventDefault();
			if (rows.length && this.highlightedRowIndex >= 0 && rows[this.highlightedRowIndex]) {
				this.selectVendor(rows[this.highlightedRowIndex]);
			} else if (this.customersearch?.nativeElement?.value?.trim()) {
				this.filterVendors({ target: { value: this.customersearch.nativeElement.value } });
			}
		}
	}

	scrollHighlightedIntoView(): void {
		setTimeout(() => {
			const el = this.tableWrapper?.nativeElement?.querySelectorAll?.('mat-row')?.[this.highlightedRowIndex];
			if (el) {
				el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
			}
		}, 0);
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
		if (this.vendosubscription && typeof this.vendosubscription.unsubscribe === 'function') {
			this.vendosubscription.unsubscribe();
		}
	}

	exportPdf() {
		// import("jspdf").then(jsPDF => {
		///import("jspdf-autotable").then(x => {
		// const doc = new jsPDF.default(0,0);
		// doc.autoTable(this.header, this.vendors);
		//doc.save('products.pdf');
		//})
		// })
	}

	exportXls() {
		const d = new Date();
		
		// Generate HTML table dynamically
		let html = '<table class="table">';
		
		// Build header row
		html += '<tr>';
		html += '<th>Vendor ID</th>';
		if (this.config && this.config.env && this.config.env.package == 'tires') {
			html += '<th>Short Code</th>';
		}
		html += '<th>Vendor Name</th>';
		html += '<th>Address</th>';
		html += '<th>Email</th>';
		html += '<th>Telephone</th>';
		html += '<th>Vendor Type</th>';
		html += '<th>Active</th>';
		html += '<th>Terms Code</th>';
		html += '<th>Terms Name</th>';
		html += '</tr>';
		
		// Build data rows
		if (this.results && this.results.length > 0) {
			this.results.forEach((vend: any) => {
				html += '<tr>';
				html += '<td class="text-left">' + (vend.supplierid || '') + '</td>';
				if (this.config && this.config.env && this.config.env.package == 'tires') {
					html += '<td class="text-left">' + (vend.bankref || '') + '</td>';
				}
				html += '<td class="text-left">' + (vend.suppname || '') + '</td>';
				html += '<td class="text-left">' + (vend.address1 || '') + '</td>';
				html += '<td class="text-left">' + (vend.email || '') + '</td>';
				html += '<td class="text-left">' + (vend.telephone || '') + '</td>';
				// Use typename if available, otherwise empty
				html += '<td class="text-left">' + (vend.typename || '') + '</td>';
				html += '<td class="text-left">' + (vend.active === 0 || vend.active === '0' ? 'No' : 'Yes') + '</td>';
				// Use termscode if available, otherwise fallback to paymentterms
				html += '<td class="text-left">' + (vend.termscode || vend.paymentterms || '') + '</td>';
				// Use termsname if available, otherwise empty
				html += '<td class="text-left">' + (vend.termsname || '') + '</td>';
				html += '</tr>';
			});
		}
		
		html += '</table>';
		
		const encoded: string = this.globalSearchService.base64encode(html);
		const data = {
			content: encoded,
			filename: 'vendor_list' + d.getMonth() + d.getDate() + d.getFullYear(),
			title: 'Vendor Export',
			subtitle: ''
		}

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
		});
	}


	saveAsExcelFile(buffer: any, fileName: string): void {
		const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
		const EXCEL_EXTENSION = '.xlsx';
		const data: Blob = new Blob([buffer], {
			type: EXCEL_TYPE
		});
		FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
	}

	back(): void {
		this.location.back()
	}

	selectVendor(row: any) {
		this.router.navigate(['./vendors/' + row.supplierid]);
	}


	ngAfterViewInit() {
		if (this.vendors?.sort) {
			this.vendors.sort = this.sort;
		}
		if (this.vendors?.paginator !== undefined) {
			this.vendors.paginator = this.paginator;
		}
		if (this.paginator?.page) {
			this.paginator.page.pipe(takeUntil(this.destroy$)).subscribe(() => {
				this.highlightedRowIndex = 0;
			});
		}
	}

	announceSortChange(sortState: Sort) {
	}

}
